import { DiModuleBuilder } from "@iot-platform/core";
import { UserDatasource } from "@user/data/datasources/user.datasource";
import { AuthenticatedUserMapper } from "@user/data/mappers/authenticated-user.mapper";
import { UserRoleEnumMapper } from "@user/data/mappers/user-role-enum.mapper";
import { UserMapper } from "@user/data/mappers/user.mapper";
import { UserImplRepository } from "@user/data/repositories/user.impl-repository";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { UserCreateUseCase } from "@user/domain/usecases/user-create.usecase";
import { UserDeleteUseCase } from "@user/domain/usecases/user-delete.usecase";
import { UserEditUseCase } from "@user/domain/usecases/user-edit.usecase";
import { UserGetByEmailUseCase } from "@user/domain/usecases/user-get-by-email.usecase";
import { UserGetByIdUseCase } from "@user/domain/usecases/user-get-by-id.usecase";
import { userTypes } from "@user/root/user-types.di";
import { ContainerModule } from "inversify";

const userModule = new DiModuleBuilder();

userModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(UserDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(AuthenticatedUserMapper).toSelf();
        bind(UserMapper).toSelf();
        bind(UserRoleEnumMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<UserRepository>(userTypes.repositories.UserRepository).to(
            UserImplRepository,
        );
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(UserCreateUseCase).toSelf();
        bind(UserDeleteUseCase).toSelf();
        bind(UserEditUseCase).toSelf();
        bind(UserGetByEmailUseCase).toSelf();
        bind(UserGetByIdUseCase).toSelf();
    }),
}));

userModule.registerModule();

export { userModule };
